import { render, staticRenderFns } from "./MobileRightMenu.vue?vue&type=template&id=0fbba955"
import script from "./MobileRightMenu.vue?vue&type=script&lang=js"
export * from "./MobileRightMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileRightMenu.vue?vue&type=style&index=0&id=0fbba955&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports